<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G71HLM/tc-custom/9781683502227.jpg?1734321748270" alt="This image is the cover for the book When I Die, Take My Panties"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">When I Die, Take My Panties
      </h1>
      <p class="bookDescription body article font2">
        <b>A daughter cares for her dying mother in this intimate memoir of ovarian cancer, frank conversations, and finding peace through laughter and gratitude.</b><br/>  <br/> In 2006, Jennifer Coken’s mother was diagnosed with stage four ovarian cancer. She had a slim chance of living another five years, but she chose to spend her remaining days tap dancing through chemotherapy and loving her family and friends ferociously. In this witty and heartfelt memoir, Jennifer recounts how she found the strength to care for her mother and cope with her death while facing troubles in her own life.<br/>  <br/> Challenging circumstances force us to face a harsh reality; so often we want to control life—and the truth is we can’t. This is a story of how personal transformation can come from tragedy if we are willing to find it. Above all, it is a wake-up call for anyone who needs the courage to have heartfelt conversations with the people they love right here, right now.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Coken
      </h2>
      
      <p class="authorDescription body article">Jen Coken spent six years on the stand-up comedy circuit in Denver and uses humor to embrace the ridiculousness of life. Jen has coached thousands of people for nearly 20 years to go beyond their self-made limitations and produce breakthrough results. Not a week goes by without Jen receiving an email from someone thanking her for making a difference in their life. After losing her mom to ovarian cancer in 2011, Jen wrote <I>When I Die, Take My Panties.</I> Jen helps the reader discover the gifts in their own lives, and find the motivation and courage to have heartfelt conversations with the people they love, right here right now. Jen’s motto is “Live every day as if it was your FIRST!” Jen lives in Maryland, loves cycling and is a member of the National Writer’s Union.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?816b300a